import ModelService from '@/contracts/ModelService'
import { http } from '@/plugins/http'
import DataResponse from '@/types/DataResponse'
import PaginatedResponse from '@/types/PaginatedResponse'
import Role from '@/types/Role'
import { AxiosResponse } from 'axios'

export default class RoleService extends ModelService<Role> {
  index(page: number, filters: string, per_page: number | undefined): Promise<AxiosResponse<PaginatedResponse<Role>>> {
    return http.get(`/api/v1/office/roles?page=${page}&${filters}&per_page=${per_page}`)
  }

  show(id: string): Promise<AxiosResponse<DataResponse<Role>>> {
    return http.get(`/api/v1/office/roles/${id}`)
  }

  store(model: Role): Promise<AxiosResponse<DataResponse<Role>>> {
    return http.post(`/api/v1/office/roles`, model)
  }

  update(id: string, model: Role): Promise<AxiosResponse<DataResponse<Role>>> {
    return http.put(`/api/v1/office/roles/${id}`, model)
  }

  destroy(model: Role): Promise<AxiosResponse> {
    return http.delete(`/api/v1/office/roles/${model.id}`)
  }
}
